/* global fetch, moment */

function initNotificationComponentAction(unreadCount) {
    return {
        notifications: [],
        unreadCount: unreadCount || 0,
        loading: true,
        markingAll: false,

        async fetchNotifications() {
            try {
                console.log('Fetching notifications...');
                this.loading = true;
                const response = await fetch('/inbox/notifications/api/unread_list/');

                if (!response.ok) {
                    throw new Error('Failed to fetch notifications');
                }

                const data = await response.json();
                console.log('Notifications data:', data);
                this.notifications = data.unread_list || [];
                this.unreadCount = data.unread_count || 0;
            } catch (error) {
                console.error('Error fetching notifications:', error);
                this.notifications = [];
                this.unreadCount = 0;
            } finally {
                this.loading = false;
            }
        },

        async markAsRead(slug, index) {
            try {
                const response = await fetch(`/inbox/notifications/mark-as-read/${slug}/`, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                if (response.ok) {
                    // Remove the notification from the list
                    this.notifications.splice(index, 1);
                    this.unreadCount = Math.max(0, this.unreadCount - 1);
                } else {
                    throw new Error('Failed to mark notification as read');
                }
            } catch (error) {
                console.error('Error marking notification as read:', error);
                // You could add a toast notification here for user feedback
            }
        },

        async markAllAsRead() {
            if (this.notifications.length === 0) return;

            try {
                this.markingAll = true;

                // Mark all notifications as read by calling the API for each one
                const promises = this.notifications.map((notification) =>
                    fetch(`/inbox/notifications/mark-as-read/${notification.slug}/`, {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    })
                );

                await Promise.all(promises);

                // Clear all notifications and reset count
                this.notifications = [];
                this.unreadCount = 0;
            } catch (error) {
                console.error('Error marking all notifications as read:', error);
                // Optionally refresh the list in case of partial failure
                await this.fetchNotifications();
            } finally {
                this.markingAll = false;
            }
        },

        getRelativeTime(timestamp) {
            return moment(timestamp).locale('en').fromNow();
        },
    }
};

window.initNotificationComponent = () => {
    window.Alpine.data('notificationComponent', (unreadCount) => {
        return initNotificationComponentAction(unreadCount);
    });
};
